import { useContext } from 'react';
import { EventsContext } from '../contexts/events';

// ----------------------------------------------------------------------

const useEvents = () => useContext(EventsContext);

export default useEvents;
